import axios from '@/plugins/http/axios.js';
import config from "@/views/products/config/product_api.js";
import config2 from "@/views/companies/config/company_api.js";
import PathUri from '@/utils/path_uri';

const _pathUri = new PathUri(config.port, config.context);
const _pathUri2 = new PathUri(config2.port, config2.context);

export const service = {
    getCompanies: (idGroup,idEmpresa, idUsuario) => {
        return axios({
            method: 'get',
            url: `${config2.baseUrl + _pathUri2.generateUri() + idGroup}/empresas/allcompanies`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    },

    getCategoriesMarketplaceProducts : (idGroup,idEmpresa, idUsuario) => {
        return axios({
            method: 'get',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/categoria/marketplace/assignment`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    },
    
    postCreateProducts: ({ idGroup, idEmpresa, idUsuario, data }) => {
    
        return axios.post(
            `${config.baseUrl + _pathUri.generateUri() + idGroup}/productos/assignProduct`,
                data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'idEmpresa': idEmpresa,
                    'idUsuario': idUsuario
                }
            }
        )
    },

    getFunctionalities: (idGroup,idEmpresa, idUsuario) => {
        return axios({
            method: 'get',
            url: `${config2.baseUrl + _pathUri2.generateUri() + idGroup}/newsUpdates/screensApp`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    },

    getCompanyDemoTypes: (idGroup, idEmpresa, idUsuario) => {
        return axios({
            method: 'get',
            url: `${config2.baseUrl + _pathUri2.generateUri() + idGroup}/empresas/tipos-empresa-demo`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    },
}
